const menuList = {
  0: [
    { 'name': '课程在线', 'type': '1-1', 'icon': 'ios-paper-outline', 'url': '/recordingCourse' },
    { 'name': '课程练习', 'type': '1-2', 'icon': 'ios-paper-outline', 'url': '/examinationBank' },
    // {'name': '试卷库', 'type': '2-1', 'icon': 'ios-paper-outline', 'url': '/examinationBank'},
    { 'name': '课件下载', 'type': '1-3', icon: 'ios-paper-outline', 'url': '/learningDatabase' },
    // {'name': '课程在线', 'type': '2-3', 'icon': 'ios-paper-outline', 'url': '/recordingCourse'},
    // {'name': '套餐', 'type': '2-4', 'icon': 'ios-paper-outline', 'url': ''},
    { 'name': '考试测评', 'type': '1-4', icon: 'ios-paper-outline', 'url': '/myExam' },
    { 'name': '每日一练', 'type': '1-12', icon: 'ios-paper-outline', 'url': '/dayPractice' },
    { 'name': '面授课程', 'type': '1-5', icon: 'ios-paper-outline', 'url': '/faceCourse' },
    { 'name': '网上商城', 'type': '1-6', icon: 'ios-paper-outline', 'url': '/eShop' },
    { 'name': '商城订单', 'type': '1-7', icon: 'ios-paper-outline', 'url': '/mallOrders' },
    { 'name': '个人账户', 'type': '1-8', icon: 'ios-paper-outline', 'url': '/businessManagement' },
    { 'name': '积分管理', 'type': '1-9', icon: 'ios-paper-outline', 'url': '/historicalRecord' },
    { 'name': '提现记录', 'type': '1-10', icon: 'ios-paper-outline', 'url': '/withdrawalRecord' },
    { 'name': '充值记录', 'type': '1-11', icon: 'ios-paper-outline', 'url': '/prepaidRecord' }
  ],
  1: [
    { name: '课程在线', type: '2-1', icon: 'ios-paper-outline', url: '/recordingCourse' },
    { name: '课程练习', type: '2-2', icon: 'ios-paper-outline', url: '/examinationBank' },
    { name: '课件下载', type: '2-3', icon: 'ios-paper-outline', url: '/learningDatabase' },
  ],
  2: [
    { name: '考试测评', type: '3-1', icon: 'ios-paper-outline', url: '/myExam' },
    { 'name': '每日一练', 'type': '3-1', icon: 'ios-paper-outline', 'url': '/dayPractice' },
  ],
  3: [
    { name: '面授课程', type: '4-1', icon: 'ios-paper-outline', url: '/faceCourse' },
  ],
  4: [
    { name: '网上商城', type: '5-1', icon: 'ios-paper-outline', url: '/eShop' },
    { name: '商城订单', type: '5-2', icon: 'ios-paper-outline', url: 'mallOrders' },
  ],
  5: [
    { name: '个人账户', type: '6-1', icon: 'ios-paper-outline', url: '/businessManagement' },
    { name: '积分管理', type: '6-2', icon: 'ios-paper-outline', url: '/historicalRecord' },
    { name: '提现记录', type: '6-3', icon: 'ios-paper-outline', url: '/withdrawalRecord' },
    { name: '充值记录', type: '6-4', icon: 'ios-paper-outline', url: '/prepaidRecord' }
  ]
}
export {
  menuList
}
